<template>
    <div style="position: relative;left: 0;top: 0;bottom: 0;right: 0;width:100%;">
        <div class="left-head">
            <span style="font-size: 0.9375rem;font-weight: 600;line-height: 2.5rem;">购买短信</span>
        </div>
        <div class="left">
            <el-row :gutter="5" class="right-row-bottom">
                <el-col :span="5" class="title-card">累计计费条数</el-col>
                <el-col :span="6">
                    <span style="font-weight: 600;">{{billingNumber}}</span><span style="margin-left: 5px;color: #6A6A6A;">条</span>
                </el-col>
                <el-col :span="5" class="title-card">累计购买条数</el-col>
                <el-col :span="6">
                    <span style="font-weight: 600;">{{purchaseNumber}}</span><span style="margin-left: 5px;color: #6A6A6A;">条</span>
                </el-col>
            </el-row>
            <el-row :gutter="5" class="right-row-bottom" style="margin-top: 0.5rem;margin-bottom: 1rem;">
                <el-col :span="5" class="title-card">剩余短信条数</el-col>
                <el-col :span="10">
                    <span style="color: #00A5B2;font-weight: 600;font-size: 1.25rem;">{{remainingNumber}}</span><span style="margin-left: 5px;color: #6A6A6A;">条</span>
                </el-col>
            </el-row>
            <div style="width: 100%;border-top: 1px #E8E8E8 solid;position: absolute;left: 0;right: 0;"></div>
            <el-row :gutter="5" class="right-row-bottom" style="margin-top: 2.5rem;">
                <el-col :span="5" class="title-card">购买条数</el-col>
                <el-col :span="5"><el-radio v-model="prepaidNum" border label="1000">1000条</el-radio></el-col>
                <el-col :span="5" :offset="1"><el-radio v-model="prepaidNum" border label="2000">2000条</el-radio></el-col>
                <el-col :span="5" :offset="1"><el-radio v-model="prepaidNum" border label="5000">5000条</el-radio></el-col>
            </el-row>
            <el-row :gutter="5" class="right-row-bottom">
                <el-col :span="5" :offset="5"><el-radio v-model="prepaidNum" border label="10000">10000条</el-radio></el-col>
                <el-col :span="5" :offset="1"><el-radio v-model="prepaidNum" border label="20000">20000条</el-radio></el-col>
                <el-col :span="5" :offset="1"><el-radio v-model="prepaidNum" border label="50000">50000条</el-radio></el-col>
            </el-row>
            <el-row :gutter="5" class="right-row-bottom" style="margin-top:1rem;">
                <el-col :span="5" class="title-card">付款方式</el-col>
                <el-col :span="7">
                    <el-radio v-model="prepaidType" border label="wxpay"><svg-icon icon-class="微信充值"></svg-icon>微信支付</el-radio>
                </el-col>
                <el-col :span="7">
                    <el-radio v-model="prepaidType" border label="alipay"><svg-icon icon-class="支付宝"></svg-icon>支付宝</el-radio>
                </el-col>
            </el-row>
            <el-row :gutter="5" class="right-row-bottom" style="margin-top: 1rem;">
                <el-col :span="5" class="title-card">付款条数</el-col>
                <el-col :span="8">
                    <el-input v-model="prepaidNum" oninput="value=value.replace(/[^\d]/g,'')">
                        <template slot="append">条</template>
                    </el-input>
                </el-col>
            </el-row>
            <el-row :gutter="5" class="right-row-bottom" style="margin-top: 1rem;">
                <el-col :span="19" :offset="5" style="font-size: 0.75rem; color: #808080;word-break: break-all;line-height: 1.5rem;">
                    {{discount}}
                </el-col>
            </el-row>
            <el-row :gutter="5" class="right-row-bottom" style="margin-top: 1rem;">
                <el-col :span="5" class="title-card">付款金额</el-col>
                <el-col :span="10">
                    <span style="color: red;">{{money}}</span><span style="margin-left: 10px;color: #6A6A6A;">元</span>
                </el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col  :offset="8" :span="5">
                    <el-button @click="pay" type="primary" :loading="buttonLoading">立即购买</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="right-head">
            <span style="font-size: 0.9375rem;font-weight: 600;line-height: 2.5rem;">购买记录</span>
            <span style="position: absolute;right: 40%;">
                <el-radio-group v-model="timePeriod" size="mini">
                    <el-radio-button label="day">日</el-radio-button>
                    <el-radio-button label="week">周</el-radio-button>
                    <el-radio-button label="month">月</el-radio-button>
                    <el-radio-button label="year">年</el-radio-button>
                </el-radio-group>
            </span>
            <span style="position: absolute;right: 1%;">
                <el-date-picker
                        size="small"
                        v-model="dateInterval"
                        type="daterange"
                        range-separator="-"
                        :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
            </span>
        </div>
        <div class="right">
            <div style="width: 100%;height:calc(100% - 2rem);">
                <flex>
                    <el-table
                            :data="tableData"
                            ref="smsPrepaidTable"
                            stripe
                            @filter-change="handleFilterChange"
                            height="100%"
                            size="small"
                            :header-row-style="{color:'black'}"
                            v-loading="tableLoading"
                            style="width: 100%">
                        <el-table-column
                                label="序号"
                                width="60">
                            <template scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="prepaidTime"
                                label="充值时间"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="amount"
                                label="充值金额（元）"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="prepaidNum"
                                label="充值数量（条）"
                                :formatter="tableIntFormat">
                        </el-table-column>
                        <el-table-column
                                prop="remaining"
                                label="充值后数量（条）"
                                :formatter="tableIntFormat">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="充值状态"
                                columnKey="prepaidStatusFilter"
                                :filters="prepaidStatusList">
                            <template scope="scope">
                                <span v-if="scope.row.status === 0">充值中</span>
                                <span v-else-if="scope.row.status === 1">充值成功</span>
                                <span v-else-if="scope.row.status === 2" style="color: red">充值失败</span>
                                <span v-else>--</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="prepaidType"
                                label="付款方式"
                                columnKey="prepaidTypeFilter"
                                :filters="prepaidTypeList"
                                :formatter="tablePrepaidType">
                        </el-table-column>
                        <el-table-column
                                prop="operationId"
                                label="操作人"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                label="打印"
                                width="80">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status === 1" size="mini" type="text"
                                           @click="printClick(scope.row)">打印凭条
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </flex>
            </div>
            <div style="width: 100%;height:2rem;text-align: center;">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[20, 50, 100, 500, 1000]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageTotal">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :title="prepaidTypeName"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                width="350px"
                top="2vh"
                center>
            <el-row :gutter="5">
                <el-col :span="24">
                    <div class="qrcode_box">
                        <canvas class="qrcode"></canvas>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col class="dialogInfo" :offset="4" :span="6">订单号:</el-col>
                <el-col class="dialogInfo" :span="14" v-text="tradeNo"></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col class="dialogInfo" :offset="4" :span="6">充值数量:</el-col>
                <el-col class="dialogInfo" :span="14"><span v-text="prepaidNum"></span> 条</el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col class="dialogInfo" :offset="4" :span="6">充值金额:</el-col>
                <el-col class="dialogInfo" :span="14"><span v-text="money"></span> 元</el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeDialog">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
  import Flex from '@/components/Flex'
  import QRCode from 'qrcode'
  import {prepaidRemaining, queryRemaining, queryPrepaidRecord, queryPrepaidResult, queryDiscount} from '@/api/smsPlatform'
  import {getStartAndEnd, format} from '@/utils/time'

  export default {
    name: 'SmsPrepaidRecord',
    components: {
      'flex': Flex
    },
    data() {
      return {
        prepaidNum: "1000",
        prepaidType: "wxpay",
        prepaidTypeName: "微信支付",
        money: "--",
        customerId: this.$store.getters.customerId,
        customerUserId: this.$store.getters.userId,
        tableData: [],
        currentPage: 1,
        pageSize: 100,
        pageTotal: 0,
        prepaidStatusFilter: [], // 发送状态筛选
        prepaidTypeFilter: [], // 充值方式筛选
        dateInterval: [],
        timePeriod: "month",
        tableLoading: false,
        prepaidStatusList: [
          {text: '充值中', value: 0},
          {text: '充值成功', value: 1},
          {text: '充值失败', value: 2}
        ],
        prepaidTypeList: [
          {text: '微信支付', value: 'wxpay'},
          {text: '支付宝', value: 'alipay'}
        ],
        remainingNumber: 0,
        billingNumber: 0,
        purchaseNumber: 0,
        qrCodeUrl: '',
        tradeNo: '',
        dialogVisible: false,
        buttonLoading: false,
        discount: '短信0.1元/条。为保证短信正常发送，请及时购买短信。'
      }
    },
    watch: {
      timePeriod(val) {  //监听时间区间变化
        if (val !== null) {
          //时间框置空
          this.dateInterval = null
          this.currentPage = 1
          this.tableByPage()
        }
      },
      dateInterval(val) {    //监听时间框变化
        if (val !== null) {
          //时间区间置空
          this.timePeriod = null
          this.currentPage = 1
          this.tableByPage()
        }
      },
      prepaidNum(val) { // 监听充值数量变化，修改金额
        if (val !== null) {
          this.selectMoney()
        }
      }
    },
    mounted() {
      this.selectDiscount()
      this.selectMoney()
      this.tableByPage()
    },
    methods: {
      tableStringFormat(row, column, cellValue) {   //表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== "") {
          return cellValue
        }
        return "--"
      },
      tableNumberFormat(row, column, cellValue) {   //表格中数字格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== "") {
          return cellValue.toFixed(2)
        }
        return "--"
      },
      tableIntFormat(row, column, cellValue) {   //表格中整数格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== "") {
          return cellValue
        }
        return "--"
      },
      tablePrepaidType(row, column, cellValue) {   //表格中充值方式格式化
        if (cellValue === 'wxpay') {
          return '微信支付'
        } else if (cellValue === 'alipay') {
          return '支付宝'
        } else {
          return "--"
        }
      },
      handleSizeChange(val) {   //每页显示条数改变
        this.pageSize = val
        if (this.currentPage <= (parseInt((this.pageTotal - 1) / this.pageSize) + 1)) {   //防止重复查询
          this.tableByPage()
        }
      },
      handleCurrentChange(val) {    //当前页数改变
        this.currentPage = val
        this.tableByPage()
      },
      handleFilterChange(filters) {  //表格筛选
        // 充值状态筛选
        if (filters.prepaidStatusFilter !== undefined) {
          this.prepaidStatusFilter = filters.prepaidStatusFilter
        }
        // 付款方式筛选
        if (filters.prepaidTypeFilter !== undefined) {
          this.prepaidTypeFilter = filters.prepaidTypeFilter
        }
        this.currentPage = 1
        //查询表格数据
        this.tableByPage()
      },
      tableByPage() { // 查询表格数据
        let startTime = null
        let endTime = null
        if (this.dateInterval !== null && this.dateInterval.length != 0) {  //时间框不为空使用时间框中的时间
          startTime = format(this.dateInterval[0], "YYYY-MM-DD HH:mm:ss")
          endTime = format(this.dateInterval[1], "YYYY-MM-DD HH:mm:ss")
        } else if (this.timePeriod !== null) {  //时间区间不为空则使用时间区间的时间
          let timeJson = getStartAndEnd("now", this.timePeriod)
          startTime = format(timeJson.start, "YYYY-MM-DD HH:mm:ss")
          endTime = format(timeJson.end, "YYYY-MM-DD HH:mm:ss")
        } else {  //都为空则为异常
          this.$message({
            type: 'error',
            message: '请选择查询时间'
          })
          return
        }
        this.tableLoading = true
        this.selectRemaining()
        // 查询充值记录
        queryPrepaidRecord(this.currentPage, this.pageSize, this.customerId, null, null, this.prepaidTypeFilter, startTime, endTime, this.prepaidStatusFilter).then(res => {
          this.tableLoading = false
          if (res.code === 200) {
            this.tableData = res.infoJson.records
            this.pageTotal = res.infoJson.total
          } else {
            this.$message({
              type: 'error',
              message: '充值记录查询失败'
            })
          }
        }).catch(error => {
          this.tableLoading = false
          this.$message({
            type: 'error',
            message: '充值记录查询失败'
          })
        })
      },
      selectDiscount(){ // 查询折扣信息
        queryDiscount(this.customerId).then(res => {
          if (res.code === 200) {
            let discountMessage = '短信0.1元/条'
            if (res.infoJson != null && res.infoJson.length > 0) {
              for (let i = res.infoJson.length - 1; i >= 0; i--) {
                discountMessage = discountMessage + '，每次购买短信达到' + res.infoJson[i].criticalNum + '条，每条短信' + res.infoJson[i].price + '元'
              }
            }
            this.discount = discountMessage + '。为保证短信正常发送，请及时购买短信。'
          }
        })
      },
      selectRemaining() { // 查询剩余条数
        queryRemaining(this.customerId).then(res => {
          if (res.code === 200) {
            this.purchaseNumber = res.infoJson.purchaseNum
            this.billingNumber = res.infoJson.billingNum
            this.remainingNumber = res.infoJson.remaining
          } else {
            this.$message({
              type: 'error',
              message: '查询剩余数量失败'
            })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '查询剩余数量失败'
          })
        })
      },
      selectMoney() { //  查询所需金额
        prepaidRemaining(this.customerId, null, this.prepaidNum, "query").then(res => {
          if (res.code === 200) {
            this.money = res.infoJson.amount.toFixed(2)
          } else {
            this.money = '--'
          }
        }).catch(error => {
          this.money = '--'
        })
      },
      selectTrade(status) { // 查询订单状态
        if (status === 1) { // 充值成功
          queryPrepaidResult(this.customerId, 1, this.customerUserId).then(res => {
            if (res.code === 200) {
              for (let i in res.infoJson) {
                const result = res.infoJson[i]
                if (this.tradeNo !== result.id) {
                  break
                }
                //整理数据
                let trade = result.id
                let operationName = "--"
                let prepaidNum = "--"
                let remaining = "--"
                let amount = "--"
                let prepaidType = "--"
                let prepaidTime = "--"
                if (result.operationId !== null && result.operationId !== undefined && result.operationId !== "") {
                  operationName = result.operationId
                }
                if (result.prepaidNum !== null && result.prepaidNum !== undefined && result.prepaidNum !== "") {
                  prepaidNum = result.prepaidNum
                }
                if (result.remaining !== null && result.remaining !== undefined && result.remaining !== "") {
                  remaining = result.remaining
                }
                if (result.amount !== null && result.amount !== undefined && result.amount !== "") {
                  amount = result.amount
                }
                if (result.prepaidType !== null && result.prepaidType !== undefined && result.prepaidType !== "") {
                  if (result.prepaidType === "wxpay") {
                    prepaidType = "微信支付"
                  } else if (result.prepaidType === "alipay") {
                    prepaidType = "支付宝"
                  }
                }
                if (result.prepaidTime !== null && result.prepaidTime !== undefined && result.prepaidTime !== "") {
                  prepaidTime = result.prepaidTime
                }
                let message = "尊敬的" + operationName + "，您已成功购买短信" + prepaidNum + "条，总计" + amount + "元。"
                let content = `<style type='text/css'>
                            .subtitle {text-align: center;font-size: 13px;font-weight: 600;margin-bottom: 2px;}
                            .title {text-align: center;font-size: 13px;margin-bottom: 10px;height: 23px;border-bottom: 1px dashed #999999;}
                            .name {width: 48%;float: left;text-align: right;padding-right: 2%;color: #464646;font-size: 10px;line-height: 15px;}
                            .value {width: 50%;float: left;font-size: 11px;line-height: 15px;white-space: normal;word-break: break-all;word-wrap: break-word;}
                         </style>
                         <div class='print'>
                            <div class='subtitle'>AcuBill网络预付费系统</div>
                            <div class='title'>短信充值记录单</div>
                            <div><div class='name'>订单号:</div><div class='value'>` + trade + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值短信数量:</div><div class='value'>` + prepaidNum + ' 条' + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值后短信数量:</div><div class='value'>` + remaining + ' 条' +  `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值金额:</div><div class='value'>` + amount + ' 元' +  `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值时间:</div><div class='value'>` + prepaidTime + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值方式:</div><div class='value'>` + prepaidType + `</div><br style='clear:both;'></div>
                            <div><div class='name'>操作人:</div><div class='value'>` + operationName + `</div><br style='clear:both;'></div>
                         </div>`
                // 显示通知
                this.showNotify("短信购买成功", "success", message, content)
              }
            }
          })
        } else if (status === 2) {  // 充值失败
          queryPrepaidResult(this.customerId, 2, this.customerUserId).then(res => {
            if (res.code === 200) {
              for (let i in res.infoJson) {
                const result = res.infoJson[i]
                //整理数据
                let operationName = "--"
                if (result.operationId !== null && result.operationId !== undefined && result.operationId !== "") {
                  operationName = result.operationId
                }
                let message = "尊敬的" + operationName + "，您购买短信失败。"
                // 显示通知
                this.showNotify("短信购买失败", "error", message)
              }
            }
          })
        }
      },
      closeDialog() { // 关闭二维码对话框
        // 初始化页面查询
        this.timePeriod = "month"
        this.prepaidStatusFilter = []
        this.prepaidTypeFilter = []
        this.$refs.smsPrepaidTable.clearFilter();
        this.selectRemaining()
        this.tableByPage()
        // 关闭对话框
        this.dialogVisible = false
        // 查询充值成功记录
        this.selectTrade(1)
      },
      pay() { // 充值按钮
        if (this.prepaidNum < 1) {
          this.$message({
            type: 'error',
            message: '购买数量必须为正数'
          })
          return
        }
        if (this.prepaidNum > 1000000) {
          this.$message({
            type: 'error',
            message: '购买数量不可超过1,000,000'
          })
          return
        }
        this.$confirm('将生成二维码进行支付, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          // 购买按钮loading
          this.buttonLoading = true
          // 清空单号和二维码url
          this.tradeNo = ''
          this.qrCodeUrl = ''
          // 修改支付方式名称
          if (this.prepaidType === 'wxpay') {
            this.prepaidTypeName = '微信支付'
          } else {
            this.prepaidTypeName = '支付宝'
          }
          prepaidRemaining(this.customerId, this.customerUserId, this.prepaidNum, this.prepaidType).then(res => {
            this.buttonLoading = false
            if (res.code === 200) {
              this.dialogVisible = true
              this.money = res.infoJson.amount.toFixed(2)
              this.qrCodeUrl = res.infoJson.qrUrl
              this.tradeNo = res.infoJson.tradeNo
              // 生成二维码
              this.$nextTick(() => {
                QRCode.toCanvas(document.querySelector('canvas'), this.qrCodeUrl)
              })
            } else {
              this.$message({
                type: 'error',
                message: '发起支付失败'
              })
            }
          }).catch(error => {
            this.buttonLoading = false
            this.$message({
              type: 'error',
              message: '发起支付失败'
            })
          })
        }).catch(() => {
        })
      },
      printClick(result) { // 打印凭条按钮
        //整理数据
        let trade = result.id
        let operationName = "--"
        let prepaidNum = "--"
        let remaining = "--"
        let amount = "--"
        let prepaidType = "--"
        let prepaidTime = "--"
        if (result.operationId !== null && result.operationId !== undefined && result.operationId !== "") {
          operationName = result.operationId
        }
        if (result.prepaidNum !== null && result.prepaidNum !== undefined && result.prepaidNum !== "") {
          prepaidNum = result.prepaidNum
        }
        if (result.remaining !== null && result.remaining !== undefined && result.remaining !== "") {
          remaining = result.remaining
        }
        if (result.amount !== null && result.amount !== undefined && result.amount !== "") {
          amount = result.amount
        }
        if (result.prepaidType !== null && result.prepaidType !== undefined && result.prepaidType !== "") {
          if (result.prepaidType === "wxpay") {
            prepaidType = "微信支付"
          } else if (result.prepaidType === "alipay") {
            prepaidType = "支付宝"
          }
        }
        if (result.prepaidTime !== null && result.prepaidTime !== undefined && result.prepaidTime !== "") {
          prepaidTime = result.prepaidTime
        }
        let content = `<style type='text/css'>
                            .subtitle {text-align: center;font-size: 13px;font-weight: 600;margin-bottom: 2px;}
                            .title {text-align: center;font-size: 13px;margin-bottom: 10px;height: 23px;border-bottom: 1px dashed #999999;}
                            .name {width: 48%;float: left;text-align: right;padding-right: 2%;color: #464646;font-size: 10px;line-height: 15px;}
                            .value {width: 50%;float: left;font-size: 11px;line-height: 15px;white-space: normal;word-break: break-all;word-wrap: break-word;}
                         </style>
                         <div class='print'>
                            <div class='subtitle'>AcuBill网络预付费系统</div>
                            <div class='title'>短信充值记录单</div>
                            <div><div class='name'>订单号:</div><div class='value'>` + trade + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值短信数量:</div><div class='value'>` + prepaidNum + ' 条'  + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值后短信数量:</div><div class='value'>` + remaining + ' 条'  + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值金额:</div><div class='value'>` + amount + ' 元'  + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值时间:</div><div class='value'>` + prepaidTime + `</div><br style='clear:both;'></div>
                            <div><div class='name'>充值方式:</div><div class='value'>` + prepaidType + `</div><br style='clear:both;'></div>
                            <div><div class='name'>操作人:</div><div class='value'>` + operationName + `</div><br style='clear:both;'></div>
                         </div>`
        //打印账单
        let newWindow = window.open("about:blank")
        newWindow.document.write(content)
        newWindow.print()
        newWindow.close()
      },
      /**
       * 显示通知
       * @param title 通知标题
       * @param type 通知类型：success/error
       * @param message 通知内容
       * @param content 待打印内容
       */
      showNotify(title, type, message, content) {
        if (type === "success") {
          this.$notify({
            title: title,
            type: type,
            dangerouslyUseHTMLString: true,
            duration: 0,
            message: this.$createElement("div", null, [
              this.$createElement("div", {
                style: {
                  "margin-bottom": "5px",
                  "word-break": "break-all"
                }
              }, message),
              this.$createElement("button", {
                on: {
                  click: function () {
                    //打印账单
                    let newWindow = window.open("about:blank")
                    newWindow.document.write(content)
                    newWindow.print()
                    newWindow.close()
                  }
                },
                attrs: {
                  class: "el-button el-button--primary"
                }
              }, "打印凭条")
            ])
          })
        } else { // 失败的不显示打印凭条按钮
          this.$notify({
            title: title,
            type: type,
            dangerouslyUseHTMLString: true,
            duration: 0,
            message: this.$createElement("div", null, [
              this.$createElement("div", {
                style: {
                  "margin-bottom": "5px",
                  "word-break": "break-all"
                }
              }, message)
            ])
          })
        }
      }
    }
  }
</script>

<style scoped>
    .left-head {
        position: absolute;
        left: 0;
        width: 35%;
        padding-left: 10px;
    }

    .right-head {
        position: absolute;
        left: 38%;
        width: 62%;
        padding-left: 10px;
    }

    .left {
        position: absolute;
        left: 0;
        top: 40px;
        bottom: 10px;
        width: 35%;
        height: calc(100% - 50px);
        background-color: #ffffff;
        border-radius: 4px;
        padding-left: 10px;
    }

    .right {
        position: absolute;
        left: 38%;
        top: 40px;
        bottom: 10px;
        width: 62%;
        height: calc(100% - 50px);
        background-color: #ffffff;
        border-radius: 4px;
    }

    .el-col {
        line-height: 40px;
    }

    .right-row-bottom{
        margin-bottom: 5px;
    }
    .title-card{
        line-height: 40px;
        font-weight: normal;
        font-size: 15px;
        color: #6A6A6A;
    }

    .qrcode_box {
        width: 300px !important;
        height: 300px !important;
        margin: 0 auto;
    }

    .qrcode {
        width: 300px !important;
        height: 300px !important;
    }

    .dialogInfo {
        word-break: break-all;
    }
</style>
